import { Select as BaseSelect } from '@base-ui/react/select';

import { Icon } from '../../assets/Icon/Icon';
import {
  arrowsColor,
  getControlVariantCompoundVariants,
} from '../../controls/Button/Button.styles';
import { selectors, transitions } from '../../controls/shared/styles';
import {
  controlArrowsSize,
  controlBorderRadius,
  controlGap,
  controlHeight,
  controlPaddingX,
  controlPaddingY,
  controlVars,
} from '../../controls/shared/vars';
import { colors, darkThemeSelector, shadows, styled } from '../../stitches.config';

export const SelectContainer = styled('div');
SelectContainer.displayName = 'SelectContainer';

export const SelectArrows = styled(Icon, {
  size: controlArrowsSize,
  color: arrowsColor,
});
SelectArrows.displayName = 'SelectArrows';

/** Shared so `ComboBox` can wear the same trigger over a Base UI `Combobox.Trigger`. */
export const selectTriggerCSS = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: controlGap,
  minHeight: controlHeight,
  paddingX: controlPaddingX,
  paddingY: controlPaddingY,
  borderRadius: controlBorderRadius,
  opacity: 1,
  truncate: true,
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  transition: transitions.control,

  [selectors.focus]: {
    outline: 'none',
  },

  variants: {
    ...controlVars,
    appearance: {
      muted: {},
      vivid: {},
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.5,
      },
      false: {},
    },
    variant: {
      alternative: {},
      attention: {},
      brand: {},
      negative: {},
      neutral: {},
      positive: {},
    },
    ghost: {
      true: {},
      false: {},
    },
    invalid: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    ...getControlVariantCompoundVariants(),

    // Invalid
    {
      isDisabled: false,
      invalid: true,
      css: {
        boxShadow: shadows.fieldErrorLight,

        '&:hover:not(:focus)': {
          boxShadow: shadows.fieldErrorLight,
        },

        [darkThemeSelector]: {
          boxShadow: shadows.fieldErrorDark,

          '&:hover:not(:focus)': {
            boxShadow: shadows.fieldErrorDark,
          },
        },
      },
    },

    // Ghost
    {
      ghost: true,
      css: {
        '&[data-ghost="true"]:not(:hover, :focus, :focus-visible, :focus-within)': {
          backgroundColor: colors.transparent,
          boxShadow: colors.transparent,
          outlineColor: colors.transparent,
        },
      },
    },
  ],
};

export const SelectTrigger = styled(BaseSelect.Trigger, selectTriggerCSS);
SelectTrigger.displayName = 'SelectTrigger';
